import PropTypes from "prop-types";
import ProcessRow from "../ProcessRow";

export default function ProcessRowAsiakas(props) {
  const thisProcess = props.thisProcess;
  const isConfirmed = props.thisProcess.asiakasHyväksytty.isConfirmed;
  const confirmDate = props.thisProcess.asiakasHyväksytty.confirmDate;

  function handleKlik() {
    if (isConfirmed) {
      thisProcess.asiakasHylkää();
    } else {
      thisProcess.asiakasHyväksy();
    }
    thisProcess.asiakasHyväksytty.isConfirmed = !isConfirmed;
    props.setThisProcess(thisProcess);
  }

  function getTip() {
    return isConfirmed ? "Poista asiakkaan hyväksyntä" : "Hyväksy asiakas heti";
  }
  return (
    <ProcessRow
      txt="Asiakas hyväksytty"
      checkTip={getTip()}
      done={isConfirmed}
      pvm={confirmDate}
      onClick={() => handleKlik()}
      aria-label="Asiakkaan hyväksyntä"
      disableTextClick
      helpId="processRowAsiakasHyväksytty"
    />
  );
}

ProcessRowAsiakas.propTypes = {
  thisProcess: PropTypes.object,
  setThisProcess: PropTypes.func,
};
